export default "__VITE_ASSET__B0AeM4Yp__"